module.exports = __webpack_public_path__ + "static/media/hero960.4b56cd3f.jpg";